import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const pullProxy: RouteRecordItem = {
  path: '/proxy/pull',
  name: 'ProxyPull',
  component: LAYOUT,
  redirect: { name: 'PullProxy' },
  meta: {
    orderNo: 8,
    icon: 'carbon:upstream',
    title: t('routes.pullProxy.拉流代理'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'detail',
      name: 'PullProxy',
      component: () => import('@/pages/stream-proxy/pull.vue'),
      meta: {
        title: t('routes.pullProxy.拉流代理'),
      },
    },
  ],
}

export default pullProxy
